import React, { useEffect } from 'react';
import { Box, LoadingSpinner } from 'edenred-ui';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from 'styled-components';
import LoginImg from '@epi-assets/images/Login.jpg';
import { goToPage } from '@epi-actions/navigation';
import { routerPaths } from '@epi-constants/routerPaths';
import { isFetching, getOtpPinId } from '@epi-selectors/login';
import { RecaptchaTerms } from '@epi-pages/Login/components';
import { OtpVerificationForm } from './components/OtpVerificationForm/OtpVerificationForm';
import { CustomerCareRedirect } from './components/CustomerCareRedirect/CustomerCareRedirect';
import { useMenuDimensions } from '@epi-shared/hooks';

const pageBoxStyle = {
  position: 'relative',
  width: '100%',
  py: { xs: '16px', md: '40px' },
  mx: 2
};

function LoginOtpVerification() {
  const dispatch = useDispatch();
  const theme = useTheme();
  const { isMobile } = useMenuDimensions();
  const isProcessing = useSelector(isFetching);
  const otpPinId = useSelector(getOtpPinId);

  useEffect(() => {
    if (!otpPinId) {
      dispatch(goToPage(routerPaths.login));
    }
  }, [dispatch, otpPinId]);

  if (!otpPinId) {
    return <LoadingSpinner />;
  }

  return (
    <Box display="flex" justifyContent="center">
      <Box sx={pageBoxStyle} maxWidth={isMobile ? 600 : 1056}>
        {isProcessing && <LoadingSpinner />}
        <Box
          display="flex"
          flexDirection={isMobile ? 'column' : 'row'}
          boxShadow="0 16px 64px 0 rgba(0, 0, 0, 0.1)"
        >
          <Box flex={1} position="relative">
            <img
              alt="Login page"
              src={LoginImg}
              style={{
                width: '100%',
                height: isMobile ? '160px' : '100%',
                objectFit: 'cover'
              }}
            />
          </Box>
          <Box bgcolor={theme.gray0} flex={1}>
            <Box maxWidth={400} px={3} py={isMobile ? 5 : 3} mx="auto">
              <OtpVerificationForm />
              <CustomerCareRedirect />
            </Box>
          </Box>
        </Box>
        <RecaptchaTerms />
      </Box>
    </Box>
  );
}

export default LoginOtpVerification;
